module.exports = __webpack_public_path__ + "img/fl_01.06d6e5b4.jpg";